export default {
  ok: 'Ok',
  optional: 'Optional'
}
